// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
const getPubnubClient = state => state.pubnub.pubnubClient;

export default getPubnubClient;
